import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "../toastService";
import { AUTH_BASE_URL, VERSION, apiClientHeaders } from "../utils/config";
import "../styles/Login.css";

export default function Login() {
  const [phone, setPhone] = useState("");
  const [policy, setPolicy] = useState(false);
  const [touched, setTouched] = useState(false);
  const [throwError, setThrowError] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const phoneRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check authentication status
    const authStatus = localStorage.getItem("isAuthenticated") === "true";

    // Redirect if authenticated
    if (authStatus) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleContinue = async () => {
    setFormLoading(true)
    if (/^\d{10}$/.test(phone) && policy) {
      setThrowError(false)
      try {
        const response = await fetch(`${AUTH_BASE_URL}/${VERSION}/user-web/login`, {
          method: "POST",
          body: JSON.stringify({ phone: "91"+phone, app_detect: "web_detect" }),
          headers: apiClientHeaders({ "Content-Type": "application/json" }),
        });

        const data = await response.json();
        setFormLoading(false);
        if (data.response_code === 200) {
          showToast("The OTP has been sent successfully!", "success");
          navigate("/otp", { state: { phone } });
        } else {
          showToast(data.message || "Error sending OTP", "error");
        }
      } catch (error) {
        setFormLoading(false);
        console.log(error)
        showToast("Failed to send OTP. Try again.", "error");
      }
    } else {
      setThrowError(true)
      setFormLoading(false)
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-content">
        {/* Logo */}
        <div className="logo">
          <img src="/assets/images/logo.png" alt="G9 Lexia Logo" />
        </div>

        {/* Title */}
        <h2 className="title">Let’s get you onboard!</h2>
        <p className="subtitle">Enter your mobile number</p>

        {/* Input */}
        <div className={`input-container ${(touched || throwError) && phone.length !== 10 ? "error" : ""}`}>
          <img className="country-code" src="/assets/images/flag.png" alt="India"></img>
          <input
            ref={phoneRef}
            type="text"
            maxLength={10}
            inputMode="numeric"
            minLength={10}
            required
            placeholder="90621 95465"
            value={phone}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (/^[0-9]*$/.test(value)) {
                setPhone(value);
                if(value.length === 10){
                  phoneRef.current.blur();
                }
              }
              if (!touched) setTouched(true); // mark as touched on first change
            }}
          />
        </div>
        { (touched || throwError) && phone.length !== 10 ? <div className="error">Please input correct number to proceed</div> : ''}
      </div>

      {/* Policy */}
      <div className="outer-policy">
        <div className="policy">
        <input
          type="checkbox"
          checked={policy}
          onChange={(e) => setPolicy(e.target.checked)}
        />
        <p>
          By continuing, I accept the <a href="https://g9eduinternational.com/terms-conditions/">terms of service</a> and{" "}
          <a href="https://g9eduinternational.com/privacy-policy/">privacy policy</a>
        </p>
      </div>
      { (touched || throwError) && !policy ? <div className="error">Please accept the policy to continue</div> : ''}
      </div>
      {/* Button fixed bottom */}
      <button onClick={handleContinue} className="continue-btn" disabled={formLoading}>
        {formLoading ? <span className="loader"></span> : "Continue"}
      </button>
    </div>
  );
}
